import { Component, Inject, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import * as APIService from '../../_shared/services/api/api-index';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as Models from '../../_shared/models/models-index';
import * as SharedServices from '../../_shared/services/services-index';
import { MinutesToHoursPipe } from '../../_shared/pipes/minutesToHours.pipe';
import { ConfigurationService, SpinnerService } from '../../_shared/services/services-index';
import { Subscription, Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
const clone = require('rfdc/default');


@Component({
  templateUrl: './leadDetailsModal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LeadDetailsModalComponent implements OnDestroy, OnInit {
  dealerLookups: Models.IDealerLookup[];
  reportConfig: Models.ILeadTransactionsConfig;
  lead$: Observable<Models.LeadTransactionTableMetricReportRecord>;
  leadDispositions$: Observable<Models.LeadTransactionDispositionReportRecord[]>;
  subscription = new Subscription();
  excludeFromTemplate: string[] = [];

  requestModel: Models.ReportRequestModel = {
    orderBy: '',
    orderAscending: false,
    reportType: '',
    filters: {
      startDate: new Date(),
      endDate: new Date(),
      orgCode5: null,
      orgCode4: null,
      orgCode3: null,
      orgCode2: null,
      orgCode1: null,
      dealerCode: null,
      leadId: null,
      orgLookupTypeId: 1,
    }
  };

  constructor(public dialogRef: MatDialogRef<LeadDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private minutesToHoursPipe: MinutesToHoursPipe,
    private reportService: APIService.LeadTransactionService,
    private configService: ConfigurationService,
    private filterService: SharedServices.FilterService,
    private spinner: SpinnerService
  ) {
    this.reportConfig = this.configService.reports.leadTransactionsConfig;
    this.requestModel.filters.leadId = data.lead.leadId;
    this.requestModel.filters.leadTypeId = data.lead.leadTypeId;
    this.requestModel.filters.roleLevel = data.roleLevel;
    this.excludeFromTemplate = data.excludeFromTemplate;
  }

  ngOnInit(): void {
    this.lead$ = this.getLeadDetails().pipe(tap(() => this.spinner.hide()));
    this.leadDispositions$ = this.getLeadDispositions().pipe(tap(() => this.spinner.hide()));
  }

  ngOnDestroy(): void {

  }

  getLeadDetails(): Observable<Models.LeadTransactionTableMetricReportRecord> {
    this.spinner.show();
    return this.filterService.filter$.pipe(
      switchMap(filterModel => {
        this.spinner.show();
        const reportRequestModel: Models.ReportRequestModel = clone(this.requestModel)
        reportRequestModel.filters = clone(filterModel);
        reportRequestModel.filters.leadId = this.data.lead.leadId;
        reportRequestModel.filters.leadTypeId = this.data.lead.leadTypeId;
        reportRequestModel.filters.roleLevel = this.data.roleLevel;

        return this.reportService.getLeadTransactionByLeadId(reportRequestModel, 'leadtransactionbyleadid').pipe(
          map(response => response.results.find(result => result.leadId === this.requestModel.filters.leadId))
        );
      })
    );
  }

  getLeadDispositions(): Observable<Models.LeadTransactionDispositionReportRecord[]> {
    this.spinner.show();
    const reportRequestModel: Models.ReportRequestModel = JSON.parse(JSON.stringify(this.requestModel));
    return this.reportService.getTransactionDispositions(reportRequestModel, 'leadtransactiondispositions').pipe(
      map(response => response.results)
    );
  }

  convertUtcToCst(date: Date): Date {
    let dateCopy = new Date(date);
    dateCopy = new Date(dateCopy.setHours(dateCopy.getHours() - 5));
    return dateCopy;
  }

  timeToRespond(minutes: number): string {
    const result = this.minutesToHoursPipe.transform(minutes);
    return result !== 'N/A' ? result : '0m';
  }

  sale(lead: Models.LeadTransactionTableMetricReportRecord): string {
    return lead.saleDate ? 'Y' : 'N';
  }

  sameDealer(lead: Models.LeadTransactionTableMetricReportRecord): string {
    if (!(lead.saleDate)) { // no sale
      return '';
    }

    if (lead.saleDealerCode.length > 1) {
      return lead.dealerCode === lead.saleDealerCode ? 'Y' : 'N';
    }

    return lead.saleDealerCode === 'S' ? 'Y' : 'N';
  }

  closeModal() {
    this.dialogRef.close();
  }
}
